import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './config.service';
import { StatusModel } from '../models/client-models';

const STATUS_ENDPOINT = 'status';

@Injectable({
  providedIn: 'root',
})
export class ApiStatusService {
  constructor(private http: HttpClient) {}

  getApiStatus() {
    return this.http.get<StatusModel>(
      AppConfig.settings.backend.url + STATUS_ENDPOINT
    );
  }

  checkStatus(server: string) {
    if (server.indexOf('/api/') === -1) {
      return this.http.get<StatusModel>(server + '/api/' + STATUS_ENDPOINT);
    } else {
      return this.http.get<StatusModel>(server + STATUS_ENDPOINT);
    }
  }
}
